module.exports = __webpack_public_path__ + "img/2.f3569588.jpg";